import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {AlertService} from "../../../services";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormControl} from "@angular/forms";
import {IPurchaseOrdersResponse} from "../../../models/responses";
import {Observable} from "rxjs";
import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";
import {ParamsSearch} from "../../../models/params";

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent<T> implements OnInit  {
  @BlockUI() blockUI: NgBlockUI;
  @Input() public  title: string;
  @Input() columns: string[];
  @Input() columnsName: string[];
  @Input() SearchData: Function;
  @Output() selectRecord: EventEmitter<T> = new EventEmitter<T>();
  /**
   * Array to store data of type T.
   */
  public data: T[];

  /**
   * FormControl for the search input.
   */
  searchInputControl = new FormControl('');

  /**
   * Current page number.
   */
  currentPage = 1;

  /**
   * Number of records to display per page.
   */
  recordsPerPage = 5;

  /**
   * Total number of records in the collection.
   */
  collectionSize: number = 15;

  constructor(
    private alertService: AlertService,
    private modalService: NgbModal
  ){
    this.searchInputControl.valueChanges.pipe(
      debounceTime(300) // Ajusta el tiempo de debounce según tus necesidades (en milisegundos)
    ).subscribe(value => {
      // Aquí puedes realizar acciones como llamar a una función para buscar resultados en función del valor del input
      console.log(value);
      this.currentPage = 1;
      this.loadData();
    });
  }


  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * This method is commonly used to perform initialization logic for the component.
   */
  ngOnInit() {
    this.loadData();
  }

  /**
   * Closes the modal dialog.
   * This method is used to close the currently open modal dialog.
   */
  CloseModal(){
    this.modalService.dismissAll();
  }

  /**
   * Requests records.
   * This method is used to request records from a data source.
   */
  RequestRecords(): void
  {
    this.currentPage = 1;
    this.loadData();
  }

  /**
   * Selects an item.
   *
   * @param item The item to be selected.
   */
  selectedRecord(item: T) {
    this.selectRecord.emit(item);
    this.modalService.dismissAll();
  }

  /**
   * Loads data.
   * This method is used to load data from a data source.
   */
  loadData() {
    let searchValue = this.searchInputControl.value;
    let searchParams:ParamsSearch =  {
      SearchValue:searchValue,
      Page:this.currentPage,
      PageRecords:this.recordsPerPage
    }

    this.SearchData(searchParams).subscribe(next => {
      if(next.length>0){
        this.data =next;
        this.collectionSize=this.collectionSize = this.data[0]['Count'];
      }else{
        this.data=[];
        this.collectionSize=0;
      }
      },
      err => {console.log(err)});
  }

  /**
   * Handles page change event.
   *
   * @param page The new page number that is selected.
   */
  onPageChange(page: number) {
    this.currentPage = page;
    this.loadData();
  }

  /**
   * Handles page size change event.
   *
   * @param size The new page size that is selected.
   */
  onPageSizeChange(size: number) {
    this.recordsPerPage = size;
    this.loadData();
  }
}
